import React, { useContext, useState } from "react";
import {
  Grid,
  useMediaQuery,
  useTheme,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  FaClipboardList,
  FaTruck,
  FaTools,
  FaCheckCircle,
  FaExclamationCircle,
  FaBox,
  FaBan,
  FaHourglassHalf,
} from "react-icons/fa";
import { OrderContext } from "../contexts/OrderContext";
import "../assets/styles/home.css";
import searchIcon from "../assets/img/icons/search.png"; // update path if needed

import newIcon from "../assets/img/icons/1.png";
import todayIcon from "../assets/img/icons/2.png";
import assignedIcon from "../assets/img/icons/7.png";
import processIcon from "../assets/img/icons/4.png";
import completeIcon from "../assets/img/icons/5.png";
import overdueIcon from "../assets/img/icons/6.png";
import issuedIcon from "../assets/img/icons/7.png";
import partialIcon from "../assets/img/icons/4.png";
import deliveredIcon from "../assets/img/icons/8.png";
import rejectedIcon from "../assets/img/icons/10.png";
import workshopIcon from "../assets/img/icons/9.png";

export const Home = () => {
  const { orders } = useContext(OrderContext);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const today = new Date();
  const userRole = localStorage.getItem("userRole");
  const [searchQuery, setSearchQuery] = useState("");

  const isToday = (date) => {
    const orderDate = new Date(date);
    return (
      orderDate.getDate() === today.getDate() &&
      orderDate.getMonth() === today.getMonth() &&
      orderDate.getFullYear() === today.getFullYear()
    );
  };

  const isOverdue = (dateString) => {
    const now = new Date();
    const date = new Date(dateString);
    now.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);
    return date < now;
  };

  const allOrders = Object.values(orders).flat();
  const deliveryField =
    userRole === "Karigar" ? "karigar_delivery_date" : "deliverydate";

  const todayDeliveryCount = allOrders.filter(
    (order) =>
      order[deliveryField] &&
      isToday(order[deliveryField]) &&
      [4].includes(order.work_status_id)
  ).length;

  const overdueCount = allOrders.filter(
    (order) =>
      order[deliveryField] &&
      isOverdue(order[deliveryField]) &&
      [4].includes(order.work_status_id)
  ).length;

  const rejectedCount = orders["Rejected"]?.length || 0;

  const rejectedByMFRCount = orders["Rejected By MFR"]?.length || 0;

  const statusIcons = {
    New: (
      <div className="mcl-icon-wrapper">
        <img src={newIcon} alt="new" className="mcl-home-icon-img" />
      </div>
    ),
    "Today Delivery": (
      <div className="mcl-icon-wrapper">
        <img src={todayIcon} alt="today" className="mcl-home-icon-img" />
      </div>
    ),
    Assigned: (
      <div className="mcl-icon-wrapper">
        <img src={assignedIcon} alt="assigned" className="mcl-home-icon-img" />
      </div>
    ),
    "In Process": (
      <div className="mcl-icon-wrapper">
        <img src={processIcon} alt="process" className="mcl-home-icon-img" />
      </div>
    ),
    Completed: (
      <div className="mcl-icon-wrapper">
        <img src={completeIcon} alt="complete" className="mcl-home-icon-img" />
      </div>
    ),
    Overdue: (
      <div className="mcl-icon-wrapper">
        <img src={overdueIcon} alt="overdue" className="mcl-home-icon-img" />
      </div>
    ),
    Issued: (
      <div className="mcl-icon-wrapper">
        <img src={issuedIcon} alt="issued" className="mcl-home-icon-img" />
      </div>
    ),
    "Partial Complete": (
      <div className="mcl-icon-wrapper">
        <img src={partialIcon} alt="partial" className="mcl-home-icon-img" />
      </div>
    ),
    Delivered: (
      <div className="mcl-icon-wrapper">
        <img
          src={deliveredIcon}
          alt="delivered"
          className="mcl-home-icon-img"
        />
      </div>
    ),
    Rejected: (
      <div className="mcl-icon-wrapper">
        <img src={rejectedIcon} alt="rejected" className="mcl-home-icon-img" />
      </div>
    ),
    "Rejected By MFR": (
      <div className="mcl-icon-wrapper">
        <img src={rejectedIcon} alt="rejected" className="mcl-home-icon-img" />
      </div>
    ),
    "Delivere To Workshop": (
      <div className="mcl-icon-wrapper">
        <img src={workshopIcon} alt="workshop" className="mcl-home-icon-img" />
      </div>
    ),
  };

  let cards = [];

  // console.log('User role:', userRole);

  const defaultCards = [
    { status: "New", text1: "New Order", link: "/status/new" },
    { status: "Assigned", text1: "Pending", link: "/status/pending" },
    { status: "Issued", text1: "Issued", link: "/status/Issued" },
    { status: "In Process", text1: "In Process", link: "/status/inProcess" },
    {
      status: "Today Delivery",
      text1: "Today Delivery",
      link: "/status/todayDelivery",
      count: todayDeliveryCount,
    },
    { status: "Completed", text1: "Completed", link: "/status/ready" },
    {
      status: "Partial Complete",
      text1: "Partial Complete",
      link: "/status/partial",
    },
    {
      status: "Overdue",
      text1: "Overdue",
      link: "/status/overdue",
      count: overdueCount,
    },
    { status: "Delivered", text1: "Delivered", link: "/status/delivered" },
    {
      status: "Delivere To Workshop",
      text1: "Delivere To Workshop",
      link: "/status/delivertoworkshop",
      count: orders["Delivery To Workshop"]?.length || 0,
    },
    {
      status: "Rejected",
      text1: "Rejected By Karigar",
      link: "/status/rejected",
      count: rejectedCount,
    },
    {
      status: "Rejected By MFR",
      text1: "Rejected By MFR",
      link: "/status/rejectedbymfr",
      count: rejectedByMFRCount,
    },
  ];

  if (["MFR", "SUPERADMIN", "COMFR", "SEMIMFR"].includes(userRole)) {
    cards = defaultCards.map((card) => ({
      ...card,
      count:
        card.count !== undefined
          ? card.count
          : orders[card.status]?.length || 0,
    }));
  } else if (userRole === "Customer") {
    cards = [
      {
        status: "New",
        text1: "New Order",
        link: "/my-orders?status=New",
        count: orders["New"]?.length || 0,
      },
      {
        status: "Issued",
        text1: "Issued",
        link: "/my-orders?status=Issued",
        count: orders["Issued"]?.length || 0,
      },
      {
        status: "In Process",
        text1: "In Process",
        link: "/my-orders?status=In%20Process",
        count: orders["In Process"]?.length || 0,
      },
      {
        status: "Completed",
        text1: "Completed",
        link: "/my-orders?status=Completed",
        count: orders["Completed"]?.length || 0,
      },
      {
        status: "Delivered",
        text1: "Delivered",
        link: "/my-orders?status=Delivered",
        count: orders["Delivered"]?.length || 0,
      },
      // { status: 'Overdue', text1: 'Overdue', link: '/status/overdue', count: overdueCount },
      // { status: 'Delivere To Workshop', text1: 'Delivere To Workshop', link: '/status/delivertoworkshop', count: orders['Delivery To Workshop']?.length || 0 },
      // { status: 'Rejected', text1: 'Rejected', link: '/status/rejected', count: rejectedCount },
    ];
  } else if (userRole === "Karigar") {
    cards = [
      {
        status: "New",
        text1: "New Order",
        link: "/status/Issued",
        count: orders["Issued"]?.length || 0,
      },
      {
        status: "Today Delivery",
        text1: "Today Delivery",
        link: "/status/todayDelivery",
        count: todayDeliveryCount,
      },
      {
        status: "In Process",
        text1: "In Process",
        link: "/status/inProcess",
        count: orders["In Process"]?.length || 0,
      },
      {
        status: "Completed",
        text1: "Completed",
        link: "/status/ready",
        count: orders["Completed"]?.length || 0,
      },
      {
        status: "Partial Complete",
        text1: "Partial Complete",
        link: "/status/partial",
        count: orders["Partial Complete"]?.length || 0,
      },
      {
        status: "Overdue",
        text1: "Overdue",
        link: "/status/overdue",
        count: overdueCount,
      },
      {
        status: "Delivere To Workshop",
        text1: "Delivere To Workshop",
        link: "/status/delivertoworkshop",
        count: orders["Delivery To Workshop"]?.length || 0,
      },
      {
        status: "Rejected",
        text1: "Rejected By Karigar",
        link: "/status/rejected",
        count: rejectedCount,
      },
      {
        status: "Rejected By MFR",
        text1: "Rejected By MFR",
        link: "/status/rejectedbymfr",
        count: rejectedByMFRCount,
      },
    ];
  }

  const filteredCards = cards.filter(
    (card) =>
      card.status.toLowerCase().includes(searchQuery.toLowerCase()) ||
      card.text1.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="mcl-home">
      <div className="custom-search-box">
        <img src={searchIcon} alt="Search" className="search-icon" />
        <input
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <Grid container spacing={1.5} sty className="mcl-home-grid">
        {filteredCards.map((card, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
            <div
              className={`mcl-home-card ${
                card.status === "Overdue" || card.status === "Today Delivery"
                  ? "red-highlight"
                  : ""
              }`}
              onClick={() => navigate(card.link)}
            >
              <div className="mcl-home-card-left">
                {statusIcons[card.status]}
              </div>
              <div className="mcl-home-card-middle">
                <div className="mcl-home-title">{card.text1}</div>
                <div className="mcl-home-subtitle">{card.status}</div>
              </div>
              <div className="mcl-home-card-right">
                <div className="mcl-count-badge">
                  <span
                    className={`mcl-count-badge ${
                      ["Today Delivery", "Overdue"].includes(card.status)
                        ? "important"
                        : ""
                    }`}
                  >
                    {card.count}
                  </span>
                </div>
              </div>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
